module.exports = __webpack_public_path__ + "img/device-tv.f37799a4.svg";